import { NgModule } from '@angular/core';
import { NbCardModule, NbIconModule, NbInputModule, NbToggleModule, NbActionsModule, NbSpinnerModule } from '@nebular/theme';
import { Ng2SmartTableModule } from 'ng2-smart-table';

import { ThemeModule } from '../../@theme/theme.module';
import { routedComponents, MessagesRoutingModule } from './messages-routing.module';
import { FormsModule } from '@angular/forms';
import { NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ShowMessageComponent } from './show-message/show-message.component';


@NgModule({
  imports: [
    NbCardModule,
    NbIconModule,
    NbInputModule,
    ThemeModule,
    MessagesRoutingModule,
    Ng2SmartTableModule,
    FormsModule,
    NbToggleModule,
    NgbModule,
    NgMultiSelectDropDownModule, 
    NbActionsModule,
    NbSpinnerModule,
  ],
  entryComponents: [
    ShowMessageComponent,
  ],
  declarations: [
    ShowMessageComponent,
    ...routedComponents,
  ],
})
export class MessagesModule { }
